var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31185 1.33268C4.31185 0.964492 4.61033 0.666016 4.97852 0.666016H12.8118C13.591 0.666016 14.2285 1.26602 14.2285 1.99935V10.6243C14.2285 11.0156 13.9114 11.3327 13.5202 11.3327C13.129 11.3327 12.8118 11.0155 12.8118 10.6243V1.99935H4.97852C4.61033 1.99935 4.31185 1.70087 4.31185 1.33268ZM2.18685 3.33268H9.97852C10.7577 3.33268 11.3952 3.93268 11.3952 4.66602V13.9993C11.3952 14.7327 10.7577 15.3327 9.97852 15.3327H2.18685C1.40768 15.3327 0.770184 14.7327 0.770184 13.9993V4.66602C0.770184 3.93268 1.40768 3.33268 2.18685 3.33268ZM2.18685 13.9993H9.97852V4.66602H2.18685V13.9993Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3258657cf2fcb395ee761e0da21ed33a.svg";
export { ForwardRef as ReactComponent };